(function () {
  function closeDialog(dialog) {
    if (!dialog) return;
    var video = dialog.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (dialog.open) dialog.close();
  }

  function initInfluencerDialogs() {
    var triggers = document.querySelectorAll('[data-influencer-video-trigger]');
    if (!triggers.length) return;

    Array.prototype.forEach.call(triggers, function (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || dialog.dataset.influencerVideoReady === 'true') return;

      dialog.dataset.influencerVideoReady = 'true';
      trigger.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
          dialog.scrollTop = 0;
          var close = dialog.querySelector('[data-influencer-video-close]');
          if (close) close.focus();
        }
      });

      var closeButton = dialog.querySelector('[data-influencer-video-close]');
      if (closeButton) closeButton.addEventListener('click', function () { closeDialog(dialog); });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('cancel', function () {
        var video = dialog.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfluencerDialogs);
  } else {
    initInfluencerDialogs();
  }
})();
